import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, SYSTEM_SUBJECT_CODE_BODY_PATH } from '../../../constant/Constant';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { request } from '../../ApiModule';
import { SET_GRID_DATA } from '../../component/TableBoxModule';

const INIT = SYSTEM_SUBJECT_CODE_BODY_PATH + PATH_DELIMITER + 'INIT';
const ACTION_SEARCH = SYSTEM_SUBJECT_CODE_BODY_PATH + PATH_DELIMITER + 'ACTION_SEARCH';
const ACTION_ADD = SYSTEM_SUBJECT_CODE_BODY_PATH + PATH_DELIMITER + 'ACTION_ADD';
const ACTION_EDIT = SYSTEM_SUBJECT_CODE_BODY_PATH + PATH_DELIMITER + 'ACTION_EDIT';
const ACTION_REMOVE = SYSTEM_SUBJECT_CODE_BODY_PATH + PATH_DELIMITER + 'ACTION_REMOVE';

export const actionInit = createAction(INIT);
export const actionSearch = createAction(ACTION_SEARCH);
export const actionAdd = createAction(ACTION_ADD);
export const actionEdit = createAction(ACTION_EDIT);
export const actionRemove = createAction(ACTION_REMOVE);

export function* systemSubjectCodeSagas() {
    yield takeEvery(ACTION_SEARCH, actionSearchSaga);
    yield takeEvery(ACTION_ADD, actionAddSaga);
    yield takeEvery(ACTION_EDIT, actionEditSaga);
    yield takeEvery(ACTION_REMOVE, actionRemoveSaga);
}

function* actionSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/subjects',
        params,
        callback,
    });
    if (NullCheckUtil.isNotNull(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionAddSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/api/subjects',
        data,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(data);
    }
}

function* actionEditSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'put',
        url: `/api/subjects/${data.subjectId}`,
        data,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(data);
    }
}

function* actionRemoveSaga({ payload: { data, callback } }) {
    const result = yield call(request, {
        method: 'delete',
        url: `/api/subjects/${data.subjectId}`,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        callback && callback(data);
    }
}
